import { RouteObject } from "react-router-dom";

const publicAdministrationRoutes: RouteObject[] = [
	{ path: "predmeti", lazy: () => import("@/pages/PublicAdministration/Cases/CasesPage") },
	{ path: "predmeti/:caseId", lazy: () => import("@/pages/PublicAdministration/Cases/CaseDetails") },
	{ path: "pismena/akti", lazy: () => import("@/pages/PublicAdministration/Pleadings/Acts/ActsPage") },
	{ path: "pismena/akti/:pleadingId", lazy: () => import("@/pages/PublicAdministration/Pleadings/Acts/ActDetails") },
	{ path: "pismena/interni-akti", lazy: () => import("@/pages/PublicAdministration/Pleadings/InternalActs/InternalActsPage") },
	{ path: "pismena/interni-akti/:pleadingId", lazy: () => import("@/pages/PublicAdministration/Pleadings/InternalActs/InternalActDetails") },
	{ path: "pismena/podnesci", lazy: () => import("@/pages/PublicAdministration/Pleadings/Submissions/SubmissionsPage") },
	{ path: "pismena/podnesci/:pleadingId", lazy: () => import("@/pages/PublicAdministration/Pleadings/Submissions/SubmissionDetails") },
	{ path: "dosjei", lazy: () => import("@/pages/PublicAdministration/Dossiers/DossiersPage") },
	{
		path: "ulazne-posiljke",
		lazy: () => import("@/pages/Page"),
		children: [
			{ index: true, lazy: () => import("@/pages/NotFoundPage") },
			{
				path: "redovne",
				children: [
					{
						path: "",
						lazy: () => import("@/pages/IncomingShipments/RegularIncomingShipments/RegularIncomingShipmentsPage")
					},
					{
						path: ":incomingShipmentId",
						lazy: () => import("@/pages/IncomingShipments/RegularIncomingShipments/RegularIncomingShipmentDetailsPage")
					}
				]
			},
			{ path: "ne-otvorene", lazy: () => import("@/pages/IncomingShipments/NotOpenedIncomingShipments/NotOpenedIncomingShipmentsPage") }
		]
	},
	{ path: "arhiva/predmeti", lazy: () => import("@/pages/Archive/ArchivedCasesPage") },
	{ path: "arhiva/sifrarnik", lazy: () => import("@/pages/Archive/ArchiveCodebooks") },
	{ path: "arhiva/arhivski-zapisi", lazy: () => import("@/pages/Archive/ArchiveLogEntries") },
	{ path: "zup-it/sifrarnik", lazy: () => import("@/pages/ZupIT/ZupItCodebooks") },
	{ path: "zup-it/korisnici", lazy: () => import("@/pages/ZupIT/ZupItUsers/ZupItUser") },
	{ path: "zup-it/izlazne-poruke", lazy: () => import("@/pages/ZupIT/OutboxMessages/OutboxMessages") },
	{
		path: "izlazne-posiljke",
		lazy: () => import("@/pages/Page"),
		children: [
			{ path: "posiljke", lazy: () => import("@/pages/OutgoingShipments/Shipments/OutgoingShipmentsPage") },
			{ path: "otpreme", lazy: () => import("@/pages/OutgoingShipments/PleadingDispatches/PleadingDispatchesPage") },
			{
				path: "email-predlosci",
				children: [
					{ path: "", lazy: () => import("@/pages/OutgoingShipments/EmailTemplates/EmailTemplatesPage") },
					{
						path: ":emailTemplateId",
						lazy: () => import("@/pages/OutgoingShipments/EmailTemplates/EmailTemplateDetailsPage")
					}
				]
			}
		]
	},
	{
		path: "dokumenti",
		lazy: () => import("@/pages/Page"),
		children: [
			{
				path: "vrste",
				children: [
					{ path: "", lazy: () => import("@/pages/DocumentTypes/DocumentTypesPage") },
					{ path: ":documentTypeId", lazy: () => import("@/pages/DocumentTypes/DocumentTypeDetailsPage") }
				]
			},
			{
				path: "podaci",
				lazy: () => import("@/pages/DocumentTypes/DocumentTypeDataPage")
			},
			{
				path: "predlosci",
				children: [
					{ path: "", lazy: () => import("@/pages/DocumentTypes/DocumentTypeTemplatesPage") },
					{
						path: ":documentTypeTemplateId",
						lazy: () => import("@/pages/DocumentTypes/DocumentTypeTemplateDetailsPage")
					}
				]
			}
		]
	},
	{
		path: "postavke-aplikacije/konfiguracija-rokova/upravni",
		lazy: () => import("@/pages/ApplicationConfig/DeadlineConfiguration/ProceedingTypeDeadlineConfiguration/ProceedingTypeDeadlineConfiguration")
	},
	{
		path: "postavke-aplikacije/konfiguracija-rokova/podnesci",
		lazy: () => import("@/pages/ApplicationConfig/DeadlineConfiguration/SubmissionDeadlineConfiguration/SubmissionDeadlineConfiguration")
	},
	{ path: "poslovni-partneri/javno-pravna-tijela", lazy: () => import("@/pages/BusinessPartners/PublicCompanies/PublicCompaniesPage") },
	{ path: "administracija/klasifikacija", lazy: () => import("@/pages/Administration/Classification/ClassificationMarks") },
	{ path: "administracija/pisarnice", lazy: () => import("@/pages/Administration/RegistryOffices/RegistryOfficesPage") }
];

export default publicAdministrationRoutes;
